import { getFreshAppAccessToken } from '@/lib/app-auth-session'

export type GetFreshAccessTokenOptions = {
  /** Skip local session reuse; only use after a 401 or when the server rejected the token. */
  forceRefresh?: boolean
}

/**
 * Resolves a valid Bearer token for FairHelm API calls. Prefer this over
 * `useAuth().session` immediately before fetch — React state can lag behind
 * the auth-session helper after refresh/expiry.
 */
export async function getFreshAccessToken(
  options?: GetFreshAccessTokenOptions,
): Promise<string | null> {
  return getFreshAppAccessToken(options)
}
